<template>
  <div class="c-button">
    <a
      :href="data.url" target="_blank" rel="noopener"
    >
      {{ data.content }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'baseButton',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-button {
  display: inline-block;
  position: relative;
  padding: 0;

  background-color: transparent;
  border: none;
  outline: transparent;

  & a {
    padding: 10px 20px;
    font-weight: 700;
    color: $color-light;

    z-index: 5;

    transition: transform 0.4s $global-ease;
  }

  & a,
  &::before,
  &::after {
    display: inline-block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &::before,
  &::after {
    content: '';

    position: absolute;

    border: 1px solid $color-text;
    border-radius: 18px;

    transition: transform 0.4s $global-ease;

    @at-root [data-conference="amsterdam"] & {
      background-color: $color-pink;
    }
    @at-root [data-conference="san-francisco"] & {
      background-color: $color-blue;
    }
    @at-root [data-conference="new-york"] & {
      background-color: $color-azure;
    }
  }

  &::before {
    transform: translateX(3px) translateY(3px);

    @at-root [data-conference="amsterdam"] & {
      background-color: #C38B87;
    }

    @at-root [data-conference="san-francisco"] & {
      background-color: darken($color-blue, 15%);
    }

    @at-root [data-conference="new-york"] & {
      background-color: darken($color-azure, 15%);
    }
  }

  @at-root .pointerevents:not(.touchevents) &:hover::after,
  .no-pointerevents.no-touchevents &:hover::after {
    transform: translateX(3px) translateY(3px);
  }

  @at-root .pointerevents:not(.touchevents) &:hover a,
  .no-pointerevents.no-touchevents &:hover a {
    transform: translateX(3px) translateY(3px);
  }
}
</style>
